// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__XMsnk","item":"Tooltip_item__WUVhO"};